import { IItem, IItemCreate, IItemUpdate } from '../typing/item.interface';

export class Item {
    data: IItem;

    constructor(data: IItem){
        this.data = data;
    }

    dataForCreate(formData: IItemCreate): IItemCreate{
        return {
            name: formData.name,
            categoryId: formData.categoryId,
            description: formData.description,
        };
    }

    dataForUpdate(formData: IItemCreate): IItemUpdate {
        return {
            id: this.data.id,
            name: formData.name,
            categoryId: formData.categoryId,
            description: formData.description,
        };
    }

    formData(): IItemCreate {
        return {
            name: this.data.name,
            categoryId: this.data.category!.id,
            description: this.data.description,
        };
    }
}
